import produce from 'immer';
import * as CONSTANTS from './constants';
import { CHAT_ROLES } from '@iso/containers/BuddiBot/_constatns';

const initState = {
  selectedChatId: null,
  thread: {
    loading: false,
    data: [],
    error: null
  },
  threads: {
    loading: false,
    data: [],
    error: null
  },
  pagination: {
    page: 1,
    count: 0
  },
  isOpenSidebar: false,
  animation: {
    isGeneratingText: false,
    text: ''
  }
};

const getUserPrompt = (text) => ({
  role: CHAT_ROLES.user,
  text: text
});

const assistantPrompt = {
  role: CHAT_ROLES.assistant,
  text: null
};

const buddibotReducer = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {

      case CONSTANTS.START_TEXT_GENERATION:
        draft.animation = {
          ...draft.animation,
          isGeneratingText: true
        };
        break;

      case CONSTANTS.STOP_TEXT_GENERATION:
        const generatedText = draft.animation.text
        draft.animation = {};
        draft.thread = {
          ...draft.thread,
          data: [
            ...draft.thread.data,
            {...assistantPrompt, text: generatedText}
          ]
        }
        break;

      case CONSTANTS.SET_TEXT:
        draft.animation = {
          ...draft.animation,
          text: action.payload
        };
        break;

      case CONSTANTS.CREATE_THREAD_REQUEST:
        draft.thread = {
          data: [getUserPrompt(action.payload), assistantPrompt],
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.CREATE_THREAD_SUCCESS:
        draft.selectedChatId = action.data.id;
        draft.thread = {
          data: [action.data.messages[0]],
          loading: false,
          error: null
        };
        break;

      case CONSTANTS.CREATE_THREAD_FAIL:
      case CONSTANTS.SEND_NEW_PROMPT_FAIL:
        draft.thread = {
          ...draft.thread,
          loading: false,
          error: action.error
        };
        break;

      case CONSTANTS.SEND_NEW_PROMPT_REQUEST:
        draft.thread = {
          data: [
            ...draft.thread.data,
            getUserPrompt(action.payload),
            assistantPrompt
          ],
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.SEND_NEW_PROMPT_SUCCESS:
        const filteredArray = draft.thread.data.filter((item) => item.text);
        draft.thread = {
          data: filteredArray,
          loading: false,
          error: null
        };
        break;

      case CONSTANTS.SET_PAGINATION_PAGE:
        draft.pagination = {
          ...draft.pagination,
          page: action.page
        };
        break;

      case CONSTANTS.FETCH_THREADS_REQUEST:
        draft.threads = {
          ...draft.threads,
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.FETCH_THREADS_SUCCESS:
        const newData = action.isStartFromScratch
          ? [...action.data.results]
          : [...draft.threads.data, ...action.data.results];

        draft.threads = {
          data: newData,
          loading: false,
          error: null
        };

        draft.pagination = {
          page: action.isStartFromScratch ? 1 : draft.pagination.page,
          count: action.data.count
        };
        break;

      case CONSTANTS.FETCH_THREADS_FAIL:
        draft.threads = {
          ...draft.threads,
          loading: false,
          error: action.error
        };
        break;

      case CONSTANTS.FETCH_THREAD_REQUEST:
        draft.selectedChatId = action.payload.id;
        draft.thread = {
          ...draft.thread,
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.FETCH_THREAD_SUCCESS:
        draft.thread = {
          data: action.data.messages,
          loading: false,
          error: null
        };
        break;

      case CONSTANTS.FETCH_THREAD_FAIL:
        draft.thread = {
          ...draft.thread,
          loading: false,
          error: action.error
        };
        break;

      case CONSTANTS.START_NEW_THREAD:
        draft.selectedChatId = null;
        draft.thread = {
          ...initState.thread
        };
        break;

      case CONSTANTS.RENAME_THREAD_REQUEST:
        draft.threads = {
          ...draft.threads,
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.RENAME_THREAD_SUCCESS:
        const newList = draft.threads.data.map((item) => {
          if (item.id === action.data.id) {
            return {
              ...item,
              label: action.data.label
            };
          }

          return item;
        });

        draft.threads = {
          data: newList,
          loading: false,
          error: null
        };
        break;

      case CONSTANTS.RENAME_THREAD_FAIL:
        draft.threads = {
          ...draft.threads,
          loading: false,
          error: action.error
        };
        break;

      case CONSTANTS.DELETE_THREAD_REQUEST:
        draft.threads = {
          ...draft.threads,
          loading: true,
          error: null
        };
        break;

      case CONSTANTS.DELETE_THREAD_SUCCESS:
        if (action.data.id === draft.selectedChatId) {
          draft.selectedChatId = null;
          draft.thread = initState.thread;
        }

        draft.threads = {
          ...draft.threads,
          loading: false,
          error: null
        };
        break;

      case CONSTANTS.DELETE_THREAD_FAIL:
        draft.threads = {
          ...draft.threads,
          loading: false,
          error: action.error
        };
        break;

      case CONSTANTS.OPEN_SIDEBAR:
        draft.isOpenSidebar = action.bool;
        break;

      default:
        return state;
    }
  });

export default buddibotReducer;
